import CandidateMyPayment from "@container/candidate-my-payment";
import AuthLayout from "@container/layout/auth";

export default function PaymentPage() {
    return (
        <AuthLayout>
            <CandidateMyPayment />
        </AuthLayout>
    )
}